import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.reports,
    name: routeNames.reports,
    component: () => import('@/pages/reports/ReportsView.vue'),
    meta: {
      permission: 'reports.read.assigned',
      icon: 'pi pi-file-export',
      labelKey: 'reports',
    },
  },
]
